export const normalizeUserGender = (gender) => String(gender || '').trim().toLowerCase();

export const getDoctorEmojiForGender = (gender) => (
  normalizeUserGender(gender) === 'female' ? '👩‍⚕️' : '👨‍⚕️'
);

export const getProfileAvatar = (user) => {
  if (!user) return '👨‍⚕️';
  if (user.role === 'doctor' || user.role === 'student') {
    return getDoctorEmojiForGender(user.gender);
  }
  return (user.name || user.email || 'U')[0].toUpperCase();
};
